<template>
  <b-navbar toggleable="lg" class="main-header navbar navbar--custom navbar-light navbar-white p-2">
    <div class="container-fluid">
      <!-- <b-navbar-toggle target="nav-collapse" style="border-color: #007bff"></b-navbar-toggle> -->
      <!-- <button class="btn btn-success" id="buttonMenuMobile" @click="closeSidebar">></button> -->
      <b-collapse id="nav-collapse" is-nav>
        <!-- <nav-menu></nav-menu> -->
        <side-bar-menu></side-bar-menu>
      </b-collapse>
      <div v-if="verificaSocorroRota" class="divSocorroRota">
        <button class="btn btn-danger" @click="showModalSocorro = true">
          <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
        </button>
        <div class="alert alert-danger alertSocorroRota" role="alert" style="position: fixed">
          Socorro em Rota pendente de atendimento!
        </div>
      </div>
      <b-navbar-brand class="navbar-brand navbar-brand--custom d-flex align-items-center ml-auto">
        <span class="d-none d-md-flex" style="align-items: center;">
          {{ dsColaborador }} |
          <v-select v-if="moreFiliais" :options="allEmpresas" v-model="selectEmpresa" placeholder="FILTRO EMPRESA"
            style="margin-left: 3px; width: 180px; font-size: 16px;" @input="filterFilial(selectEmpresa)"></v-select>

          <v-select v-if="moreFiliais" :options="allFiliais" v-model="selectFiliais" :placeholder="filialName"
            style="margin-left: 3px; width: 180px; font-size: 16px;" @input="chooseFilial(selectFiliais)"></v-select>
          <b v-if="!moreFiliais"> {{ filialName }}</b>
        </span>
        <span class="d-block d-md-none" maxlengh="10" id="spanMobile">
          {{ dsColaborador }} |
          <v-select v-if="moreFiliais" :options="allFiliais" v-model="selectFiliais" :placeholder="filialName"
            style="margin-left: 3px; width: 180px; font-size: 16px; margin-bottom: 5px;"
            @input="chooseFilial(selectFiliais)"></v-select>
          <b v-if="!moreFiliais"> {{ filialName }}</b>
        </span>
        <button class="btn btn-light" v-if="filialFiltrada" @click="setAllFiliais"><i class="fa fa-times"
            aria-hidden="true"></i></button>
        <span class="d-none ml-3 d-md-block">
          <button class="btn btn-primary" @click="logout">
            <i class="fas fa-sign-out-alt"></i> {{ $t('Sair') }}
          </button>
        </span>
      </b-navbar-brand>
      <modal-socorro-rota v-if="showModalSocorro" @showModalSocorro="showModalSocorro = false"></modal-socorro-rota>
      
    <div v-if="verificaHost" class="alert alert-warning col-12 text-center" role="alert" style="color: #ffffff; background-color: #ff1000; position: fixed; top: 70px; height: 32px;
    padding-top: 3px;">
      ATENÇÃO! RODANDO EM AMBIENTE DE TESTE!
    </div>
    </div>
  </b-navbar>
</template>

<script>
// import NavMenu from '@/components/NavBar/NavMenu'
import SideBarMenu from '@/components/NavBar/SideBarMenu'
import ModalSocorroRota from '@/components/Modais/ModalSocorroRota'

export default {
  components: {
    // NavMenu,
    SideBarMenu,
    ModalSocorroRota,
  },
  data() {
    return {
      selectFiliais: '',
      selectEmpresa: '',
      filialFiltrada: false,
      showModalSocorro: false,
      verificaSocorroRota: false
    }
  },
  created() {
    const filial = this.$store.getters['filial/filial']

    this.selectFiliais = filial.ds_filial.substring(0, 10)

    this.getSocorroRota()
  },
  computed: {
    verificaHost() {
      const host = window.location.hostname

      if(host ==  'terminaldaoficina.ginfo.app.br') {
        return true
      }
      
      return false

    },

    getEmpresas() {
      let empresas = this.$store.getters['os/getEmpresas']

      if (!empresas) {
        this.$store.dispatch('os/getEmpresas')

        return []
      }

      return empresas.map(empresa => {
        return {
          ...empresa,
          label: empresa.name.toUpperCase()
        }
      })
    },
    moreFiliais() {
      const filial = this.$store.getters['filial/filial']

      if (filial.allFiliais.length > 1) {
        return true
      }

      return false
    },
    dsColaborador() {
      const dsColaborador = this.$store.getters['filial/filial']

      return dsColaborador.dsColaborador.substring(0, 10)
    },
    allFiliais() {
      const filial = this.$store.getters['filial/filial']

      if (filial.fornecExt == 'S') {
        const filialTodos = {
          ds_empresa: "TODAS",
          ds_filial: "TODAS",
          nr_sequencial: -1
        }

        filial.allFiliaisTemp.push(filialTodos)
      }

      if (filial.allFiliaisTemp.length > 1) {
        return filial.allFiliaisTemp.map(element => {
          return {
            ...element,
            label: element.ds_filial
          }
        })
      }

      return []
    },

    allEmpresas() {
      const filial = this.$store.getters['filial/filial']

      try {
        if (filial.allEmpresas.length >= 1) {
          return filial.allEmpresas.map(element => {
            return {
              ...element,
              label: element.ds_empresa
            }
          })
        }
      } catch (error) {
        // console.log(error)
      }

      return []
    },
    filialName() {
      const filial = this.$store.getters['filial/filial']

      if (filial) {
        return filial.ds_filial
      }

      return null
    },
    logo() {
      return this.$store.state.logo
    }
  },
  methods: {
    getSocorroRota() {
      this.$store.dispatch('os/getSocorroRota').then(response => {

        if (response.data.length == 0) {
          this.verificaSocorroRota = false
        } else {
          this.verificaSocorroRota = true
        }
      })
    },

    filterFilial(empresa) {
      this.filialFiltrada = true

      const filialString = localStorage.getItem("filial")

      const filial = JSON.parse(filialString);

      const filiaisFiltered = filial.allFiliais.filter(item => item.ds_empresa == empresa.label)

      filial.allFiliaisTemp = filiaisFiltered;

      this.$store.commit('filial/setFilial', filial)

      localStorage.empresaFilial = empresa.label;

    },

    setAllFiliais() {
      this.selectEmpresa = ''

      this.filialFiltrada = false

      const filialString = localStorage.getItem("filial")

      const filial = JSON.parse(filialString);

      const filiaisFiltered = filial.allFiliais

      filial.allFiliaisTemp = filiaisFiltered;

      this.$store.commit('filial/setFilial', filial)
    },

    closeSidebar() {
      const sidebar = document.getElementById('sidebar')
      const iconSidebar = document.getElementById('spanIconSidebar')
      const content = document.getElementById('layout-top-nav')
      const divColaborador = document.getElementById('divColaborador')

      const isMobile = window.screen.width;

      if (isMobile <= 991) {
        if (sidebar.style.width == '70px') {
          sidebar.style.width = '300px'
          iconSidebar.textContent = 'X',
            divColaborador.style.display = 'block'
        } else {
          sidebar.style.width = '0px'
          iconSidebar.textContent = '☰'
          divColaborador.style.display = 'none'
        }
      }
    },
    async chooseFilial(value) {
      const colab = this.$store.getters['filial/filial']
      colab.infColab.newFilial = value.nr_sequencial
      colab.infColab.nameNewFilial = value.ds_filial
      colab.infColab.ambiente_temp = colab.ambiente


      this.$store
        .dispatch('filial/login', { data: colab.infColab })
        .then(() => {
          // this.$store.dispatch('colaborador/loadMecanicos')
          this.hasError = false

          window.location.reload(true);

          // const filial = this.$store.getters['filial/filial']

          // if (filial.fornecExt === 'S') {
          //   window.location = '/osExterna'
          //   // this.$router.push('/osExterna').catch(err => { console.error(err) })
          // } else {
          //   window.location = '/'
          // }
        })
        .catch((err) => {
          console.error(err)
          this.hasError = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    logout() {
      this.$store.dispatch('filial/logout')
    }
  }
}
</script>
<style src="./style.css"  scoped />
<style lang="scss">
.navbar-brand--custom {
  position: absolute;
  top: 10px;
  right: 0;
  font-size: 17px;
}

.navbar--custom {
  height: 78px;
}


.brand-image--custom {
  max-height: 40px;
  width: 40px !important;
  height: 40px !important;
  margin-left: 0.5rem;
  margin-top: 0 !important;
  margin-right: 0.5rem !important;
  background-color: white;
  padding: 2px;
}
</style>
